import {
    H2,
    Regular
} from '@worthy-npm/clarity';

import React from "react";
import I18n from "lib/i18n/i18n";
import UserActions from "lib/userActions";
import {connect} from "react-redux";
import {
    // Item states
    DELIVERED,
    PENDING_AUCTION
} from 'helpers/ApplicationHelper';


class CoronaPage extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {

        return (<div key='corona-container' className={'corona-container'}>
                <H2 text={"Important COVID-19 Update"} />
                <br/>
                <br/>
                <Regular text={"We are temporarily not accepting any new valuables for auction, following New York Governor Andrew Cuomo’s order for all non-essential businesses in the state to temporarily close as of Sunday, March 22nd to limit the spread of COVID-19."}/>
                <br/>
                <br/>
                <Regular text={"In case your valuable is currently on it’s way to us or is already in our possession, please check your inbox for important information."}/>
                <br/>
                <br/>
                <Regular text={"We will keep you informed as the situation evolves, and also as soon as we become operational again."}/>
                <br/>
                <br/>
                <Regular text={"Please take care of yourself and your family and reach out to us via email or by phone at 888-222-0208 if you have any questions."}/>
                <br/>
                <Regular text={"Sincerely,"}/>
                <Regular text={"Worthy"}/>

        </div>)
    }

}

// const mapStateToProps = ({ Item, Session }) => {
//     return {
//         Item: Item,
//         Session: Session
//     }
// };

// export default connect(mapStateToProps)(Survey);
export default CoronaPage;